import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../auth/services/auth.service';
import { LanguageService } from '../shared/serviceLayer/language.service';


@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router, private languageService: LanguageService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const currentUser = this.authService.currentUserValue;
        if (!currentUser || !currentUser.token) {
            const homeUrl = this.languageService.getLanguageAwareUrl('/home');
            this.router.navigateByUrl(homeUrl);
            return false;
        }
        if (!currentUser.termsAccepted) {
            const signInUrl = this.languageService.getLanguageAwareUrl('/sign-in?terms=true');
            this.router.navigateByUrl(signInUrl);
            return false;
        }
        if (currentUser?.userType) {
            if (route.data && route.data.allowedRoles) {
                if (route.data.allowedRoles.includes(currentUser.userType)) {
                    return true;
                } else {
                    if (currentUser.userType === 2 || currentUser.userType === 3) {
                        const sellerDashUrl = this.languageService.getLanguageAwareUrl('/dashboard/seller/dashboard');
                        this.router.navigateByUrl(sellerDashUrl);
                        return false;
                    }
                    if (currentUser.userType === 4 || currentUser.userType === 5) {
                        const buyerDashUrl = this.languageService.getLanguageAwareUrl('/dashboard/buyer/dashboard');
                        this.router.navigateByUrl(buyerDashUrl);
                        return false;
                    }
                }
            }
            return true;
        } else {
            const homeUrl = this.languageService.getLanguageAwareUrl('/home');
            this.router.navigateByUrl(homeUrl);
            return false;
        }
    }
}